import cx from '../../utils/cx.js';
import PropTypes from 'prop-types';
import React from 'react';
import ImageSvg from '../images/ImageSvg.react';

const ReactPropTypes = PropTypes;

class CloseIcon extends React.Component {
	static propTypes = {
	  large: ReactPropTypes.bool,
	  onClick: ReactPropTypes.func,
	};

	static defaultProps = {
	  large: false,
	  onClick: null,
	};

	render() {
	  return (
  <a
    href="#"
    className={cx([
					'close',
					['close--large', this.props.large],
				])}
    onClick={this.props.onClick}
  >
    <ImageSvg svg="icon-close" full />
  </a>
	  );
	}
}

module.exports = CloseIcon;
